const parserArrayFromObject = (response) => {
  return Object.entries(response).map(([key, value]) => {
    return {
      [key]: value
    };
  });
};

export const parseAxiosError = (response, notification, setNotification, setError = null) => {

  if (!response) {
    return;
  }

  if (Array.isArray(response[0])) {
    const parseError = response.flat().toString();
    return setNotification({...notification, visible: true, type: "error", message: parseError});
  }

  if (!Array.isArray(response[0]) && setError) {
    setError({});

    const customResponse = !Array.isArray(response) ? parserArrayFromObject(response) : response;

    let errorsCustom = {};

    customResponse.forEach(elementError => {

      const [key, value] = Object.entries(elementError).flat();

      errorsCustom[key] = value;
    });

    return setError(prev => ({ ...prev, ...errorsCustom }));
  }

  if (!setError && response[0]) {
    const purseClosableErrors = Object.values(response[0]).toString();
    return setNotification({...notification, visible: true, type: "error", message: purseClosableErrors});
  }

};